import { computed, Injectable, signal } from "@angular/core";
import { SessionStateModel } from "../Dto/SessionStateModel";
import { SessionWithDeviceInfo, PaginationInfo } from "../Dto/SessionModel";
import { SearchSessionRequest } from "../Dto/SessionSearchRequest";

const initialState: SessionStateModel = {
  sessions: [],
  loading: false,
  error: null,
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    pages: 1,
  },
  searchParams: {
    page: 1,
    limit: 10,
  },
};

@Injectable({ providedIn: "root" })
export class SessionState {
  private readonly state = signal<SessionStateModel>(initialState);

  public readonly sessions = computed(() => this.state().sessions);
  public readonly loading = computed(() => this.state().loading);
  public readonly error = computed(() => this.state().error);
  public readonly pagination = computed(() => this.state().pagination);
  public readonly searchParams = computed(() => this.state().searchParams);

  setSessions(data: SessionWithDeviceInfo[], pagination: PaginationInfo): void {
    this.state.update((currentState) => ({
      ...currentState,
      sessions: data,
      pagination,
    }));
  }

  setSearchParams(params: SearchSessionRequest): void {
    this.state.update((currentState) => ({
      ...currentState,
      searchParams: params,
    }));
  }

  setLoading(loading: boolean): void {
    this.state.update((currentState) => ({ ...currentState, loading }));
  }

  setError(error: string | null): void {
    this.state.update((currentState) => ({ ...currentState, error }));
  }

  addSession(session: SessionWithDeviceInfo): void {
    this.state.update((currentState) => ({
      ...currentState,
      sessions: [session, ...currentState.sessions],
      pagination: {
        ...currentState.pagination,
        total: currentState.pagination.total + 1,
        pages: Math.ceil((currentState.pagination.total + 1) / currentState.pagination.limit),
      },
    }));
  }

  removeSession(sessionId: string): void {
    this.state.update((currentState) => ({
      ...currentState,
      sessions: currentState.sessions.filter((session) => session.id !== sessionId),
      pagination: {
        ...currentState.pagination,
        total: currentState.pagination.total - 1,
        pages: Math.ceil((currentState.pagination.total - 1) / currentState.pagination.limit),
      },
    }));
  }
}
